<template>
  <Scrollama :debug="false" :offset="1" :progress="true" @step-progress="stepProgress">
    <div class="graphic" id="port-box-top" slot="graphic">
      <img class="scrollytell-image top" :src='bottomImage'>
      <img class="scrollytell-image top" :src='topImage' id="fadeOut">
    </div>
    <div class="step left layout-right" id="step-1" data-step-no="1">
      <prismic-rich-text :field="text" />
    </div>
  </Scrollama>
</template>

<script>
  import 'intersection-observer'
  import Scrollama from 'vue-scrollama'
  export default {
    components: {
      Scrollama
    },
    props: [
      'element',
      'topImage',
      'bottomImage',
      'text'
    ],
    mounted() {
      this.resolveAlignment()
    },
    methods: {
      stepProgress({
        element,
        index,
        progress
      }) {
        // console.log(element, index, progress)
        if (index == 0) {
          // console.log(progress);
          let opacity = this.map(progress, 0, 0.90, 1, 0);
          document.getElementById('fadeOut').style.opacity = opacity;
        }
      },
      resolveAlignment() {
        let alignment = this.element.primary.alignment;
        let DOMElement = this.$el.querySelector('.graphic')

        if(alignment == 'left') {
          DOMElement.classList.add('image-switcher-align-left')
        }
        if(alignment == 'center') {
          DOMElement.classList.add('image-switcher-align-center')
        }
        if(alignment == 'right') {
          DOMElement.classList.add('image-switcher-align-right')
        }
      },
      map(value, x1, y1, x2, y2) {
        return (value - x1) * (y2 - x2) / (y1 - x1) + x2
      }
    }
  }
</script>

<style lang="scss">
  @import '../../../assets/scss/base.scss';
  .image-switcher{
    &-align-left {
      width: 50%;
      @include md () {
        width: 100%;
      }
    }
    &-align-right {
      position: relative;
      left: 50%;
      width: 50%;
      @include md () {
       left: 0;
       width: 100%;
      }
    }
  }
</style>

<style lang="scss" scoped>
  @import '../../../assets/scss/base.scss';

  #step-1 {
    margin-bottom: 10vh;
  }

  .step {
    padding: 15vh 0;
    width: 50%;
    margin: 0 auto 30vh;
    display: flex;
  }

  .scrollytell-image {
    position: absolute;
    object-fit: contain;

    &.top {
      z-index: 10;
    }

    @include lg() {
      width: 150% !important;
      left: 0
    }
  }
</style>